var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup91FacebookFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1834 6.13352C13.9849 6.30832 13.0223 6.97507 12.5177 7.9799C12.1579 8.6966 12.0731 9.21319 12.0728 10.692L12.0726 11.761L10.9689 11.7729L9.86528 11.7847L9.79151 11.8759C9.7219 11.9619 9.71777 12.0467 9.71777 13.3837C9.71777 14.5456 9.72762 14.8138 9.77251 14.8752C9.82393 14.9456 9.89523 14.9514 10.9403 14.9695L12.0533 14.9888L12.0726 18.3365L12.0919 21.6842L12.1798 21.7721L12.2677 21.8601H13.7369H15.2061L15.2993 21.7518L15.3924 21.6434V18.308V14.9724L16.6843 14.9613C17.8642 14.9511 17.9821 14.9442 18.045 14.8812C18.1087 14.8175 18.1139 14.7026 18.1139 13.3671V11.922L18.0261 11.8341C17.9387 11.7466 17.9312 11.746 16.6625 11.7345L15.3868 11.7229L15.3993 10.6922C15.4116 9.67495 15.413 9.65936 15.5082 9.49109C15.6825 9.18311 15.7526 9.16551 16.9835 9.12112C17.9275 9.08707 18.0616 9.07441 18.1223 9.01357C18.1857 8.95007 18.1911 8.83812 18.1911 7.59152V6.23837L18.1 6.1646C18.014 6.09496 17.9352 6.09106 16.7103 6.0955C15.9961 6.09808 15.3089 6.11518 15.1834 6.13352Z",
    fill: "#FF9900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup91FacebookFooter);
export default __webpack_public_path__ + "static/media/Group 91facebook_footer.73331c4d7f35cd668caf4e5a0cdd361a.svg";
export { ForwardRef as ReactComponent };